export const SMALL_DESKTOP_WIDTH = 1419;
export const SMALL_DESKTOP_HEIGHT = 768;
